<mat-form-field appearance="fill" >
  <mat-label> {{ texts.report.dateRangeIntern | translate }} </mat-label>

  <mat-date-range-input [rangePicker]="picker" [formGroup]="range" >
    <input matStartDate formControlName="start" placeholder="Start date" (dateChange)="onChange()"/>
    <input matEndDate formControlName="end" placeholder="End date" (dateChange)="onChange()" />
  </mat-date-range-input>

  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-date-range-picker #picker></mat-date-range-picker>
</mat-form-field>
